/* tslint:disable */
/* eslint-disable */
/**
 * Telematics API
 * Telematics services API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Tag create input
 * @export
 * @interface TagCreateModel
 */
export interface TagCreateModel {
    /**
     * 
     * @type {string}
     * @memberof TagCreateModel
     */
    name: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof TagCreateModel
     */
    settings: { [key: string]: object; };
    /**
     * 
     * @type {number}
     * @memberof TagCreateModel
     */
    tagCategoryId: number;
}

export function TagCreateModelFromJSON(json: any): TagCreateModel {
    return TagCreateModelFromJSONTyped(json, false);
}

export function TagCreateModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): TagCreateModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'settings': json['settings'],
        'tagCategoryId': json['tag_category_id'],
    };
}

export function TagCreateModelToJSON(value?: TagCreateModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'settings': value.settings,
        'tag_category_id': value.tagCategoryId,
    };
}


